// Claude: AI Chat API — POST /ai-chat/message wired to Gemini function calling 25-02-2026
import { api } from "./config/axiosConfig.js";
import { store } from "../redux/Store.ts";
import { errorResponseHandler, responseHandler } from "../Utils/handler.ts";

const getToken = () => store.getState().user?.token;

export const AiChatAPI = {
  // Claude: N19 — Free-form text generation for profile "Generate with AI" feature 04-03-2026
  // Uses /generate-text instead of /message because the main chat endpoint runs Gemini with
  // platform function-calling tools, which misfires on generic text generation prompts.
  generateText: async (prompt) => {
    try {
      const response = await api.request({
        url: "/ai-chat/generate-text",
        method: "POST",
        data: { prompt },
        headers: { Authorization: `Bearer ${getToken()}` },
      });
      return responseHandler(response);
    } catch (err) {
      throw errorResponseHandler(err);
    }
  },
  sendMessage: async (message, conversationHistory, eventId) => {
    try {
      const response = await api.request({
        url: "/ai-chat/message",
        method: "POST",
        data: { message, conversationHistory, eventId },
        headers: { Authorization: `Bearer ${getToken()}` },
      });
      return responseHandler(response);
    } catch (err) {
      throw errorResponseHandler(err);
    }
  },
};
